import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";

export const isGoalEditable = (
	goal: Pick<GoalDetail, "allowEditByClient" | "completed">,
): boolean => goal.allowEditByClient && !goal.completed;
